import {
    IntentKind,
    makeIntentBuilderFunction,
    type RouteableIntent,
} from '@jet-app/music-classical/intents';

export enum DetailPageType {
    Chart = 'charts',
    Genre = 'genre',
    Instrument = 'instrument',
    Multiroom = 'multi-room',
    Period = 'period',
    Recording = 'recording',
    Work = 'work',
}

/**
 * List of `pageType`s that can be handled by DetailPageIntent
 */
export const DETAIL_PAGE_TYPE_ALLOWLIST = [
    DetailPageType.Chart,
    DetailPageType.Genre,
    DetailPageType.Instrument,
    DetailPageType.Multiroom,
    DetailPageType.Period,
    DetailPageType.Recording,
    DetailPageType.Work,
];

export interface DetailPageIntent extends RouteableIntent {
    $kind: IntentKind;
    entityPath?: string;
    id?: string;
    pageType: DetailPageType;
}

export const makeDetailPageIntent = makeIntentBuilderFunction<DetailPageIntent>(
    IntentKind.DETAIL_PAGE,
);
